import { PageTypes } from 'src/utils/analytics/trackers/internal-gtm-tracker/helpers/get-page-type';

export const injectPageType = (payloadData: string | undefined, pageType: PageTypes | null): string | undefined => {
  if (!pageType || !payloadData) {
    return payloadData;
  }

  return payloadData.replace(/{pageType}/g, pageType);
};
